import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import { startObservability } from "./lib/observability";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element is missing from index.html");
}

// Heartbeat / track / error capture. No-ops until the user signs in
// (getSession() returns null), so the public marketing surface isn't
// instrumented.
startObservability();

createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
